<template>
    <div class="card">
        <div class="title">{{ title }}</div>
        <div class="content" v-if="!type">{{ content }}</div>
        <div v-else>
            <el-select v-model="selectValue">
                <el-option :label="value" value="1"></el-option>
                <el-option :label="value" value="2"></el-option>
                <el-option :label="value" value="3"></el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
import "@/assets/style/card.less";

export default {
  data() {
    return {
      selectValue: "1"
    };
  },
  props: ["title", "content", "type", "value"],
};
</script>